import { NgModule } from '@angular/core';
import { PrimengModule } from './primeng/primeng.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { ContextMenuModule } from 'ngx-contextmenu';
import { AngularSlickgridModule } from 'angular-slickgrid';

import { CueTableComponent } from '../components/cue-table/cue-table.component';
import { DriverLogSheetChartComponent } from '../components/driver-log-sheet-chart/driver-log-sheet-chart.component';
import { SidebarComponent } from '../components/sidebar/sidebar.component';
import { AutoCompleteComponent } from '../components/auto-complete/auto-complete.component';
import { TabComponent } from '../components/tab/tab.component';
import { MultiSelectComponent } from '../components/multi-select/multi-select.component';
import { FormComponent } from '../components/form/form.component';
import { DateTimePickerComponent } from '../components/date-time-picker/date-time-picker.component';
import { TimerComponent } from '../components/timer/timer.component';
import { DragDropComponent } from '../components/drag-drop/drag-drop.component';
import { FileUploadComponent } from '../components/file-upload/file-upload.component';
import { ModalPopupComponent } from '../components/modal-popup/modal-popup.component';
import { ModifiedUserComponent } from '../components/modified-user/modified-user.component';
import { ModalPopUpService } from '../components/modal-popup/modal-popup.service';
import { FileUploadService } from '../components/file-upload/file-upload.service';
import { StepperComponent } from '../components/stepper/stepper.component';
import { GmapComponent } from '../components/gmap/gmap.component';
import { ModifiedUserService } from '../components/modified-user/modified-user.service';
import { MultiColumnSearch } from '../pipes/multi-column-search.pipe';
import { OwlDateTimeModule, OwlNativeDateTimeModule, OWL_DATE_TIME_LOCALE } from 'ng-pick-datetime';
import { DayViewComponent } from '../components/day-view/day-view.component';
import { ContextMenuComponent } from '../components/context-menu/context-menu.component';
import { ModalComponent } from '../components/modal/modal.component';
import { DebounceClickDirective } from '../Directives/prevent-dbl-click.directive';
import { PlanRequestModalComponent } from '../../business-process/plan/plan-list/plan-request-modal/plan-request-modal.component';
import { PlanModalComponent } from '../../reports/request-modal/plan-modal.component';
import { ChartFilterPipe } from '../components/gantt-chart/char-filter.pipe';
import { GanttChartComponent } from '../components/gantt-chart/gantt-chart.component';
import { QRCodeModule } from 'angularx-qrcode';
import { SplitModalComponent } from 'src/app/business-process/plan/plan-list/split-modal/split-modal.component';
import { ReworkConfigService } from 'src/app/business-process/plan/plan-list/rework-config.service';
import { ObjectLengthPipe } from '../pipes/object-length.pipe';

@NgModule({
  entryComponents: [
    FileUploadComponent,
    ModalPopupComponent,
    AutoCompleteComponent,
    DateTimePickerComponent,
    ModalComponent,
    ContextMenuComponent,
    PlanModalComponent,
    PlanRequestModalComponent,
    MultiSelectComponent,
    SplitModalComponent
  ],
  declarations: [
    CueTableComponent,
    DriverLogSheetChartComponent,
    SidebarComponent,
    AutoCompleteComponent,
    TabComponent,
    MultiSelectComponent,
    FormComponent,
    DateTimePickerComponent,
    TimerComponent,
    DragDropComponent,
    FileUploadComponent,
    ModalPopupComponent,
    ModifiedUserComponent,
    StepperComponent,
    GmapComponent,
    DayViewComponent,
    ContextMenuComponent,
    ModalComponent,

    MultiColumnSearch,

    DebounceClickDirective,
    PlanModalComponent,
    PlanRequestModalComponent,
    GanttChartComponent,

    ChartFilterPipe,
    ObjectLengthPipe

  ],
  imports: [
    CommonModule,
    PrimengModule,
    FormsModule,
    AngularSlickgridModule.forRoot(),
    ReactiveFormsModule,
    NgSelectModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    ContextMenuModule,
    QRCodeModule
  ],
  exports: [

    ContextMenuModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    PrimengModule,
    QRCodeModule,
	OwlDateTimeModule,
	OwlNativeDateTimeModule,
    CueTableComponent,
    DriverLogSheetChartComponent,
    SidebarComponent,
    AutoCompleteComponent,
    TabComponent,
    MultiSelectComponent,
    FormComponent,
    DateTimePickerComponent,
    TimerComponent,
    DragDropComponent,
    FileUploadComponent,
    ModalPopupComponent,
    ModifiedUserComponent,
    StepperComponent,
    GmapComponent,
    DayViewComponent,
    ContextMenuComponent,
    ModalComponent,
    GanttChartComponent,

    MultiColumnSearch,
    ObjectLengthPipe,

    DebounceClickDirective
  ],
  providers: [
    ModalPopUpService,
    FileUploadService,
    ModifiedUserService,
    ReworkConfigService,
    // { provide: OWL_DATE_TIME_FORMATS, useValue: MY_NATIVE_FORMATS },
    { provide: OWL_DATE_TIME_LOCALE, useValue: 'en-GB' },
  ]
})
export class AppSharedModule { }
